import collaborationSettingsComponent from './collaboration-settings.component';

const collaborationSettingsModule = angular.module('collaboration-settings', [
])
  .component('collaborationSettings', collaborationSettingsComponent)
  .name;

export default collaborationSettingsModule;
